import { createUseStyles } from 'react-jss'

const styleOverride = createUseStyles({
  root: {
    position: 'relative',
    width: '22px',
    '& .bellStyle': {
      width: '25px',
      height: '25px',
      minWidth: '25px',
      minHeight: '25px',
      strokeMiterlimit: '10',
      strokeWidth: '1',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      fill: '#FFFFFF',
      stroke: '#6A148E',
    },
    '& .notificationDot': {
      width: '8px',
      height: '8px',
      position: 'absolute',
      right: '1px',
      top: '2px'
    },
    '& .bell': {},
  },
})

export default styleOverride
